'use client';
import React, { Suspense } from 'react';
import { useBundleSelection } from '@/components/product/product-context';
import { useModal } from '@/components/modal/ModalProvider';
import Price from '@/components/price/Price';
import BundleProductItem from './BundleProductItem';
import { useCampaign } from '@/app/CampaignContext';

export default function BundleInventory({ block, position }) {
  const { title, total_savings_message, _metadata } = block.bundle_inventory;
  const { showPriceDetails } = useModal();
  const campaign = useCampaign();

  function handlePriceModalClick(e, uid) {
    // Handles the click event to show the price details modal
    e.preventDefault();
    showPriceDetails(uid, null, campaign?.pricing_details || '');
  }

  return (
    <div
      id={`${_metadata.uid}-${position}`}
      data-name="bundle-inventory"
      className={`bg-parlor-green-95 p-4 not-last:mb-8`}
    >
      <div className="flex justify-between">
        <div className="sh12 text-white">{title}</div>
        <div className="body-xs text-dawn-grey-30 text-right underline">
          <button
            className="cursor-pointer underline"
            onClick={(e) => handlePriceModalClick(e, _metadata.uid)}
          >
            Price details
          </button>
        </div>
      </div>
      <div className="min-h-76.75">
        <Suspense fallback={null}>
          <BundleInventoryDetails
            totalSavingsMessageTemplate={total_savings_message}
            variantUid={_metadata.uid}
          />
        </Suspense>
      </div>
    </div>
  );
}

/**
 * Reads bundle selection state, so it needs to be wrapped in a Suspense tag.
 */
function BundleInventoryDetails({ totalSavingsMessageTemplate, variantUid }) {
  const bundleState = useBundleSelection();
  const priceSummary = bundleState.priceSummary;
  const totalSavingsMessage = totalSavingsMessageTemplate?.includes('[amount]')
    ? totalSavingsMessageTemplate.replace(
        '[amount]',
        priceSummary.discountPrice
      )
    : totalSavingsMessageTemplate;

  return (
    <>
      {bundleState.currentOffers.map((offer, index) => (
        <BundleProductItem key={index} offer={offer} variant={variantUid} />
      ))}
      <div className="sh12 text-light-green mt-4">{totalSavingsMessage}</div>
      <div className="border-dawn-grey-60 relative mt-6 flex justify-between border-t pt-5">
        <div className="badge-text-r border-light-green text-light-green max-w-1/2 self-center rounded-full border px-4 py-1 text-center text-wrap min-[68.75rem]:max-w-45">
          ${priceSummary.compareAtPrice - priceSummary.price} total savings
        </div>
        <div className="self-center">
          <Price
            price={priceSummary.price}
            compareAtPrice={priceSummary.compareAtPrice}
            priceClassOverride="price-l text-orange!"
            crossedPriceClassOverride="price-l-crossed text-dawn-grey-60!"
            variant={`bundle-inventory${variantUid}`}
          />
        </div>
      </div>
    </>
  );
}
